import styled from 'styled-components';

interface CoverImgProps {
  imageUrl: string;
}

export const CoverImg = styled.div<CoverImgProps>`
  max-width: 100%;
  min-height: 100vh;
  background: url(${({ imageUrl }) => imageUrl});
  background-size: 100% 100%;
  background-position: center center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
`;
